import { Component } from 'react'
import { withAuth, ProtectedElement } from '@praxis/component-auth'
import { Route, Routes } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  withStyles,
  Typography,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@material-ui/core'
import { closeSideNav, openSideNav } from '../../store/layout/actionCreator'
import { Helmet } from 'react-helmet'
import { shape, string, func, bool, object } from 'prop-types'
import SideBar from './SideBar'

import { Email } from '@material-ui/icons'
import AppHeader from '../Header/Header'
import HomePage from '../HomePage/HomePage'
import ProtectedOutlet from '../ProtectedOutlet'
import LandingPage from '../LandingPage/LandingPage'
import Notifications from '../Notifications/Notifications'
import AuditDetailsTable from '../AuditLog/AuditDetailsTable'
import ReportingTable from '../ReportingPage/ReportingTable'
import ReportDetailsWrapper from '../ReportDetailsLayout/ReportDetailsWrapper'
import DoNotCallPageWrapper from '../DoNotCall/DoNotCallPageWrapper'
import MessageTemplateItemsWrapper from '../MessageTemplate/MessageTemplateItemsWrapper'
import DistributionListItemsPageWrapper from '../DistributionList/DistributionListItemsWrapper'

const styles = (theme) => ({
  root: {
    top: '0',
    left: '0',
    width: '100%',
    height: '100vh',
    display: 'flex',
    flex: '1 0 auto',
    flexDirection: 'column',
  },
  contentContainer: {
    padding: '60px 0px 10px 0px',
    flex: '1 1 auto',
    overflow: 'visible',
    boxShadow:
      '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)',
  },
  icon: {
    width: 22,
    height: 22,
    fill: 'currentColor',
    paddingRight: 5,
  },
  footer: {
    margin: '0px',
    height: '140px',
    width: '100%',
    backgroundColor: '#e0e0e0',
    paddingTop: '35px',
    zIndex: -1,
  },
  footerList: {
    flexWrap: 'wrap',
    fontSize: '0.8em',
    listStyle: 'none',
    margin: 0,
    '& li': {
      padding: '2px',
      marginLeft: '10px',
    },
    '& a': {
      textDecoration: 'none',
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row',
      color: 'rgba(0, 0, 0, 0.54)',
    },
  },
  insidefooter: {
    paddingLeft: '35px',
  },
})

export class AppLayout extends Component {
  state = {
    bcpOpen: false,
    ceebackupOpen: false,
    fmocdcOpen: false,
    frswfmOpen: false,
    hrOpen: false,
    c3Open: false,
    c3aOpen: false,
    precallOpen: false,
    developerOpen: false,
    shiptOpen: false,
  }

  static propTypes = {
    classes: object,
    headerTitle: string,
    openSideNav: func,
    closeSideNav: func,
    user: shape({
      email: string,
      isAuthorized: bool,
    }),
  }

  static defaultProps = {
    classes: {},
    headerTitle: undefined,
    layoutActions: {},
    notificationActions: {},
    user: {
      email: undefined,
      isAuthorized: undefined,
      memberOf: undefined,
    },
  }

  handleMenuButtonClick = () => {
    if (this.props.sideNavIsOpen) {
      this.props.closeSideNav()
    } else {
      this.props.openSideNav()
    }
  }

  handleCloseSideNav = () => {
    if (this.props.sideNavIsOpen) {
      this.props.closeSideNav()
    }
  }

  render() {
    const { headerTitle, sideNavIsOpen, classes } = this.props
    const commonPermissions = [
      'APP-OAUTH2-NS-VSAPIDeveloper-NP',
      'APP-OAUTH2-NS-VSAPIDeveloper-PRD',
      'APP-OAUTH2-TOM-Developer',
    ]
    return (
      <div className={classes.root}>
        <Helmet defaultTitle="notifyui" titleTemplate="%s - notifyui" />
        <Notifications />
        <SideBar open={sideNavIsOpen} onClose={this.handleCloseSideNav} />
        <AppHeader
          title={headerTitle}
          // classes={classes}
          menuAction={() => this.handleMenuButtonClick()}
        />
        <div className={classes.contentContainer}>
          <Grid container>
            <Grid item xs={12}>
              <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route
                  path="/shipt_message_template_maintenance"
                  element={
                    <ProtectedElement
                      allowed={[
                        ...commonPermissions,
                        'APP-OAUTH2-TOM-Shipt',
                        'APP-OAUTH2-TOM-Shipt-Reporting',
                      ]}
                    >
                      <MessageTemplateItemsWrapper
                        key="shipt_message_template_maintenance"
                        ciDataInput="shipt"
                        blossomIDFromParent="shipt"
                      />
                    </ProtectedElement>
                  }
                  exact
                />
                <Route
                  path="/hr_message_template_maintenance"
                  element={
                    <ProtectedElement
                      allowed={[...commonPermissions, 'APP-OAUTH2-TOM-StoreHR']}
                    >
                      <MessageTemplateItemsWrapper
                        key="hr_message_template_maintenance"
                        ciDataInput="CI00598283"
                        blossomIDFromParent="CI00598283"
                      />
                    </ProtectedElement>
                  }
                  exact
                />
                <Route
                  path="/c3_message_template_maintenance"
                  element={
                    <ProtectedElement
                      allowed={[...commonPermissions, 'APP-OAUTH2-TOM-C3']}
                    >
                      <MessageTemplateItemsWrapper
                        key="c3_message_template_maintenance"
                        ciDataInput="c3alert"
                        blossomIDFromParent="c3alert"
                      />
                    </ProtectedElement>
                  }
                  exact
                />
                <Route
                  path="/c3a_message_template_maintenance"
                  element={
                    <ProtectedElement
                      allowed={[...commonPermissions, 'APP-OAUTH2-TOM-C3A']}
                    >
                      <MessageTemplateItemsWrapper
                        key="c3a_message_template_maintenance"
                        ciDataInput="c3aalert"
                        blossomIDFromParent="c3aalert"
                      />
                    </ProtectedElement>
                  }
                  exact
                />
                <Route
                  path="/recall_message_template_maintenance"
                  element={
                    <ProtectedElement
                      allowed={[...commonPermissions, 'APP-OAUTH2-TOM-Recall']}
                    >
                      <MessageTemplateItemsWrapper
                        key="recall_message_template_maintenance"
                        ciDataInput="precall"
                        blossomIDFromParent="precall"
                      />
                    </ProtectedElement>
                  }
                  exact
                />
                <Route element={<ProtectedOutlet {...this.props} />}>
                  <Route
                    path="/bcp_message_template_maintenance"
                    element={
                      <ProtectedElement
                        allowed={[...commonPermissions, 'APP-OAUTH2-TOM-BCP']}
                      >
                        <MessageTemplateItemsWrapper
                          key="bcp_message_template_maintenance"
                          ciDataInput="bcp"
                          blossomIDFromParent="bcp"
                        />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/ceebackup_message_template_maintenance"
                    element={
                      <ProtectedElement
                        allowed={[
                          ...commonPermissions,
                          'APP-OAUTH2-TOM-CEEBackup',
                        ]}
                      >
                        <MessageTemplateItemsWrapper
                          key="ceebackup_message_template_maintenance"
                          ciDataInput="ceebackup"
                          blossomIDFromParent="ceebackup"
                        />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/fmocdc_message_template_maintenance"
                    element={
                      <ProtectedElement
                        allowed={[
                          ...commonPermissions,
                          'APP-OAUTH2-TOM-FMOCDC',
                        ]}
                      >
                        <MessageTemplateItemsWrapper
                          key="fmocdc_message_template_maintenance"
                          ciDataInput="fmocdc"
                          blossomIDFromParent="fmocdc"
                        />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/hr_distribution_list_maintenance"
                    element={
                      <ProtectedElement
                        allowed={[
                          ...commonPermissions,
                          'APP-OAUTH2-TOM-StoreHR',
                        ]}
                      >
                        <DistributionListItemsPageWrapper
                          key="hr_distribution_list_maintenance"
                          ciDataInput="CI00598283"
                          blossomIDFromParent="CI00598283"
                        />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/c3_distribution_list_maintenance"
                    element={
                      <ProtectedElement
                        allowed={[...commonPermissions, 'APP-OAUTH2-TOM-C3']}
                      >
                        <DistributionListItemsPageWrapper
                          key="c3_distribution_list_maintenance"
                          ciDataInput="c3alert"
                          blossomIDFromParent="c3alert"
                        />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/c3a_distribution_list_maintenance"
                    element={
                      <ProtectedElement
                        allowed={[...commonPermissions, 'APP-OAUTH2-TOM-C3A']}
                      >
                        <DistributionListItemsPageWrapper
                          key="c3a_distribution_list_maintenance"
                          ciDataInput="c3aalert"
                          blossomIDFromParent="c3aalert"
                        />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/recall_distribution_list_maintenance"
                    element={
                      <ProtectedElement
                        allowed={[
                          ...commonPermissions,
                          'APP-OAUTH2-TOM-Recall',
                        ]}
                      >
                        <DistributionListItemsPageWrapper
                          key="recall_distribution_list_maintenance"
                          ciDataInput="precall"
                          blossomIDFromParent="precall"
                        />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/bcp_distribution_list_maintenance"
                    element={
                      <ProtectedElement
                        allowed={[...commonPermissions, 'APP-OAUTH2-TOM-BCP']}
                      >
                        <DistributionListItemsPageWrapper
                          key="bcp_distribution_list_maintenance"
                          ciDataInput="bcp"
                          blossomIDFromParent="bcp"
                        />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/developer_distribution_list_maintenance"
                    element={
                      <ProtectedElement allowed={commonPermissions}>
                        <DistributionListItemsPageWrapper
                          key="developer_distribution_list_maintenance"
                          ciDataInput="developer"
                          blossomIDFromParent="developer"
                        />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/ceebackup_distribution_list_maintenance"
                    element={
                      <ProtectedElement
                        allowed={[
                          ...commonPermissions,
                          'APP-OAUTH2-TOM-CEEBackup',
                        ]}
                      >
                        <DistributionListItemsPageWrapper
                          key="ceebackup_distribution_list_maintenance"
                          ciDataInput="ceebackup"
                          blossomIDFromParent="ceebackup"
                        />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/fmocdc_distribution_list_maintenance"
                    element={
                      <ProtectedElement
                        allowed={[
                          ...commonPermissions,
                          'APP-OAUTH2-TOM-FMOCDC',
                        ]}
                      >
                        <DistributionListItemsPageWrapper
                          key="fmocdc_distribution_list_maintenance"
                          ciDataInput="fmocdc"
                          blossomIDFromParent="fmocdc"
                        />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/shipt_distribution_list_maintenance"
                    element={
                      <ProtectedElement
                        allowed={[
                          ...commonPermissions,
                          'APP-OAUTH2-TOM-Shipt',
                          'APP-OAUTH2-TOM-Shipt-Reporting',
                        ]}
                      >
                        <DistributionListItemsPageWrapper
                          key="shipt_distribution_list_maintenance"
                          ciDataInput="shipt"
                          blossomIDFromParent="shipt"
                        />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/developer_message_template_maintenance"
                    element={
                      <ProtectedElement allowed={commonPermissions}>
                        <MessageTemplateItemsWrapper
                          key="developer_message_template_maintenance"
                          ciDataInput="developer"
                          blossomIDFromParent="developer"
                        />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/c3a_donotcall"
                    element={
                      <ProtectedElement
                        allowed={[...commonPermissions, 'APP-OAUTH2-TOM-C3A']}
                      >
                        <DoNotCallPageWrapper
                          key="c3aalertdonotcall"
                          ciDataInput="c3aalert"
                          blossomIDFromParent="c3aalert"
                        />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/recall_donotcall"
                    element={
                      <ProtectedElement
                        allowed={[
                          ...commonPermissions,
                          'APP-OAUTH2-TOM-Recall',
                        ]}
                      >
                        <DoNotCallPageWrapper
                          key="precalldonotcall"
                          ciDataInput="precall"
                          blossomIDFromParent="precall"
                        />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/hr_donotcall"
                    element={
                      <ProtectedElement
                        allowed={[
                          ...commonPermissions,
                          'APP-OAUTH2-TOM-StoreHR',
                        ]}
                      >
                        <DoNotCallPageWrapper
                          key="CI00598283donocall"
                          ciDataInput="CI00598283"
                          blossomIDFromParent="CI00598283"
                        />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/c3_donotcall"
                    element={
                      <ProtectedElement
                        allowed={[...commonPermissions, 'APP-OAUTH2-TOM-C3']}
                      >
                        <DoNotCallPageWrapper
                          key="c3alertdonotcall"
                          ciDataInput="c3alert"
                          blossomIDFromParent="c3alert"
                        />
                      </ProtectedElement>
                    }
                    exact
                  />
                  \{' '}
                  <Route
                    path="/fmocdc_donotcall"
                    element={
                      <ProtectedElement
                        allowed={[
                          ...commonPermissions,
                          'APP-OAUTH2-TOM-FMOCDC',
                        ]}
                      >
                        <DoNotCallPageWrapper
                          key="bcpdonotcall"
                          ciDataInput="fmocdc"
                          blossomIDFromParent="fmocdc"
                        />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/shipt_donotcall"
                    element={
                      <ProtectedElement
                        allowed={[
                          ...commonPermissions,
                          'APP-OAUTH2-TOM-Shipt',
                          'APP-OAUTH2-TOM-Shipt-Reporting',
                        ]}
                      >
                        <DoNotCallPageWrapper
                          key="shipt_donotcall"
                          ciDataInput="shipt"
                          blossomIDFromParent="shipt"
                        />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/bcp_donotcall"
                    element={
                      <ProtectedElement
                        allowed={[
                          ...commonPermissions,
                          'APP-OAUTH2-TOM-BCP-Reporting',
                        ]}
                      >
                        <DoNotCallPageWrapper
                          key="bcpdonotcall"
                          ciDataInput="bcp"
                          blossomIDFromParent="bcp"
                        />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/ceebackup_donotcall"
                    element={
                      <ProtectedElement
                        allowed={[
                          ...commonPermissions,
                          'APP-OAUTH2-TOM-CEEBackup',
                        ]}
                      >
                        <DoNotCallPageWrapper
                          key="ceebackupdonotcall"
                          ciDataInput="ceebackup"
                          blossomIDFromParent="ceebackup"
                        />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/developer_donotcall"
                    element={
                      <ProtectedElement allowed={commonPermissions}>
                        <DoNotCallPageWrapper
                          key="developerdonotcall"
                          ciDataInput="developer"
                          blossomIDFromParent="developer"
                        />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/recall_crisis_reporting"
                    element={
                      <ProtectedElement
                        allowed={[
                          ...commonPermissions,
                          'APP-OAUTH2-TOM-Recall-Reporting',
                        ]}
                      >
                        <ReportingTable
                          key="precallreporting"
                          ciDataInput="precall"
                          blossomIDFromParent="precall"
                        />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/c3a_crisis_reporting"
                    element={
                      <ProtectedElement
                        allowed={[
                          ...commonPermissions,
                          'APP-OAUTH2-TOM-C3A-Reporting',
                        ]}
                      >
                        <ReportingTable
                          key="c3aalertreporting"
                          ciDataInput="c3aalert"
                          blossomIDFromParent="c3aalert"
                        />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/c3_crisis_reporting"
                    element={
                      <ProtectedElement
                        allowed={[
                          ...commonPermissions,
                          'APP-OAUTH2-TOM-C3-Reporting',
                        ]}
                      >
                        <ReportingTable
                          key="c3alertreporting"
                          ciDataInput="c3alert"
                          blossomIDFromParent="c3alert"
                        />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/hr_crisis_reporting"
                    element={
                      <ProtectedElement
                        allowed={[
                          ...commonPermissions,
                          'APP-OAUTH2-TOM-StoreHR-Reporting',
                        ]}
                      >
                        <ReportingTable
                          key="CI00598283reporting"
                          ciDataInput="CI00598283"
                          blossomIDFromParent="CI00598283"
                        />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/shipt_reporting"
                    element={
                      <ProtectedElement
                        allowed={[
                          ...commonPermissions,
                          'APP-OAUTH2-TOM-Shipt',
                          'APP-OAUTH2-TOM-Shipt-Reporting',
                        ]}
                      >
                        <ReportingTable
                          key="shiptreporting"
                          ciDataInput="shipt"
                          blossomIDFromParent="shipt"
                        />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/fmocdc_crisis_reporting"
                    element={
                      <ProtectedElement
                        allowed={[
                          ...commonPermissions,
                          'APP-OAUTH2-TOM-FMOCDC-Reporting',
                        ]}
                      >
                        <ReportingTable
                          key="fmocdcreporting"
                          ciDataInput="fmocdc"
                          blossomIDFromParent="fmocdc"
                        />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/ceebackup_crisis_reporting"
                    element={
                      <ProtectedElement
                        allowed={[
                          ...commonPermissions,
                          'APP-OAUTH2-TOM-CEEBackup',
                        ]}
                      >
                        <ReportingTable
                          key="ceebackupreporting"
                          ciDataInput="ceebackup"
                          blossomIDFromParent="ceebackup"
                        />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/bcp_crisis_reporting"
                    element={
                      <ProtectedElement
                        allowed={[
                          ...commonPermissions,
                          'APP-OAUTH2-TOM-BCP-Reporting',
                        ]}
                      >
                        <ReportingTable
                          key="bcpcrisisreporting"
                          ciDataInput="bcp"
                          blossomIDFromParent="bcp"
                        />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/reporting_details/:jobID/:blossomID"
                    element={
                      <ProtectedElement
                        allowed={[
                          ...commonPermissions,
                          'APP-OAUTH2-TOM-C3A',
                          'APP-OAUTH2-TOM-BCP-Reporting',
                          'APP-OAUTH2-TOM-CEEBackup-Reporting',
                          'APP-OAUTH2-TOM-StoreHR-Reporting',
                          'APP-OAUTH2-TOM-C3-Reporting',
                          'APP-OAUTH2-TOM-C3A-Reporting',
                          'APP-OAUTH2-TOM-Recall-Reporting',
                          'APP-OAUTH2-TOM-FMOCDC-Reporting',
                          'APP-OAUTH2-TOM-Shipt',
                          'APP-OAUTH2-TOM-Shipt-Reporting',
                        ]}
                      >
                        <ReportDetailsWrapper key="reportingdetails" />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/developer_reporting"
                    element={
                      <ProtectedElement allowed={commonPermissions}>
                        <ReportingTable
                          key="developerreporting"
                          ciDataInput="developer"
                          blossomIDFromParent="developer"
                        />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/developer_auditlog"
                    element={
                      <ProtectedElement allowed={commonPermissions}>
                        <AuditDetailsTable
                          key="developerauditlog"
                          ciDataInput="developer"
                          blossomIDFromParent="developer"
                        />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/hr_auditlog"
                    element={
                      <ProtectedElement
                        allowed={[
                          ...commonPermissions,
                          'APP-OAUTH2-TOM-StoreHR',
                        ]}
                      >
                        <AuditDetailsTable
                          key="hrauditlog"
                          ciDataInput="CI00598283"
                          blossomIDFromParent="CI00598283"
                        />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/shipt_auditlog"
                    element={
                      <ProtectedElement
                        allowed={[
                          ...commonPermissions,
                          'APP-OAUTH2-TOM-Shipt',
                          'APP-OAUTH2-TOM-Shipt-Reporting',
                        ]}
                      >
                        <AuditDetailsTable
                          key="shiptauditlog"
                          ciDataInput="shipt"
                          blossomIDFromParent="shipt"
                        />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/fmocdc_auditlog"
                    element={
                      <ProtectedElement
                        allowed={[
                          ...commonPermissions,
                          'APP-OAUTH2-TOM-FMOCDC',
                        ]}
                      >
                        <AuditDetailsTable
                          key="fmocdcauditlog"
                          ciDataInput="fmocdc"
                          blossomIDFromParent="fmocdc"
                        />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/c3a_auditlog"
                    element={
                      <ProtectedElement
                        allowed={[...commonPermissions, 'APP-OAUTH2-TOM-C3A']}
                      >
                        <AuditDetailsTable
                          key="c3aalertauditlog"
                          ciDataInput="c3aalert"
                          blossomIDFromParent="c3aalert"
                        />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/developer_custom_notification"
                    element={
                      <ProtectedElement allowed={commonPermissions}>
                        <HomePage
                          key="developercustomnotification"
                          ciDataInput="developer"
                          listDataType="teammember"
                          listDataInput={true}
                        />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/developer_notification"
                    element={
                      <ProtectedElement allowed={commonPermissions}>
                        <HomePage key="developer" ciDataInput="developer" />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/bcp_crisis_notification"
                    element={
                      <ProtectedElement
                        allowed={[...commonPermissions, 'APP-OAUTH2-TOM-BCP']}
                      >
                        <HomePage key="bcp" ciDataInput="bcp" />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/bcp_auditlog"
                    element={
                      <ProtectedElement
                        allowed={[...commonPermissions, 'APP-OAUTH2-TOM-BCP']}
                      >
                        <AuditDetailsTable
                          key="bcpauditlog"
                          ciDataInput="bcp"
                          blossomIDFromParent="bcp"
                        />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/recall_auditlog"
                    element={
                      <ProtectedElement
                        allowed={[
                          ...commonPermissions,
                          'APP-OAUTH2-TOM-Recall',
                        ]}
                      >
                        <AuditDetailsTable
                          key="precallauditlog"
                          ciDataInput="precall"
                          blossomIDFromParent="precall"
                        />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/c3_auditlog"
                    element={
                      <ProtectedElement
                        allowed={[...commonPermissions, 'APP-OAUTH2-TOM-C3']}
                      >
                        <AuditDetailsTable
                          key="c3alertauditlog"
                          ciDataInput="c3alert"
                          blossomIDFromParent="c3alert"
                        />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/bcp_custom_notification"
                    element={
                      <ProtectedElement
                        allowed={[...commonPermissions, 'APP-OAUTH2-TOM-BCP']}
                      >
                        <HomePage
                          key="bcpcustom"
                          ciDataInput="bcp"
                          listDataType="teammember"
                          listDataInput={true}
                        />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/ceebackup_crisis_custom_notification"
                    element={
                      <ProtectedElement
                        allowed={[
                          ...commonPermissions,
                          'APP-OAUTH2-TOM-CEEBackup',
                        ]}
                      >
                        <HomePage
                          key="ceebackupcustom"
                          ciDataInput="ceebackup"
                          listDataType="teammember"
                          listDataInput={true}
                        />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/ceebackup_crisis_notification"
                    element={
                      <ProtectedElement
                        allowed={[
                          ...commonPermissions,
                          'APP-OAUTH2-TOM-CEEBackup',
                        ]}
                      >
                        <HomePage key="ceebackup" ciDataInput="ceebackup" />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/fmocdc_crisis_notification"
                    element={
                      <ProtectedElement
                        allowed={[
                          ...commonPermissions,
                          'APP-OAUTH2-TOM-FMOCDC',
                        ]}
                      >
                        <HomePage key="fmocdc" ciDataInput="fmocdc" />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/shipt_notification"
                    element={
                      <ProtectedElement
                        allowed={[
                          ...commonPermissions,
                          'APP-OAUTH2-TOM-Shipt',
                          'APP-OAUTH2-TOM-Shipt-Reporting',
                        ]}
                      >
                        <HomePage key="shipt" ciDataInput="shipt" />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/shipt_custom_notification"
                    element={
                      <ProtectedElement
                        allowed={[
                          ...commonPermissions,
                          'APP-OAUTH2-TOM-Shipt',
                          'APP-OAUTH2-TOM-Shipt-Reporting',
                        ]}
                      >
                        <HomePage
                          key="shiptcustom"
                          ciDataInput="shipt"
                          listDataType="teammember"
                          listDataInput={true}
                        />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/hr_crisis_notification"
                    element={
                      <ProtectedElement
                        allowed={[
                          ...commonPermissions,
                          'APP-OAUTH2-TOM-StoreHR',
                        ]}
                      >
                        <HomePage key="CI00598283" ciDataInput="CI00598283" />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/hr_crisis_custom_notification"
                    element={
                      <ProtectedElement
                        allowed={[
                          ...commonPermissions,
                          'APP-OAUTH2-TOM-StoreHR',
                        ]}
                      >
                        <HomePage
                          key="CI00598283custom"
                          ciDataInput="CI00598283"
                          listDataType="teammember"
                          listDataInput={true}
                        />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/c3_crisis_notification"
                    element={
                      <ProtectedElement
                        allowed={[...commonPermissions, 'APP-OAUTH2-TOM-C3']}
                      >
                        <HomePage key="c3alert" ciDataInput="c3alert" />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/c3_custom_notification"
                    element={
                      <ProtectedElement
                        allowed={[...commonPermissions, 'APP-OAUTH2-TOM-C3']}
                      >
                        <HomePage
                          key="c3alertcustom"
                          ciDataInput="c3alert"
                          listDataType="teammember"
                          listDataInput={true}
                        />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/c3a_crisis_notification"
                    element={
                      <ProtectedElement
                        allowed={[...commonPermissions, 'APP-OAUTH2-TOM-C3A']}
                      >
                        <HomePage key="c3aalert" ciDataInput="c3aalert" />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/c3a_custom_notification"
                    element={
                      <ProtectedElement
                        allowed={[...commonPermissions, 'APP-OAUTH2-TOM-C3A']}
                      >
                        <HomePage
                          key="c3aalertcustom"
                          ciDataInput="c3aalert"
                          listDataType="teammember"
                          listDataInput={true}
                        />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/recall_crisis_notification"
                    element={
                      <ProtectedElement
                        allowed={[
                          ...commonPermissions,
                          'APP-OAUTH2-TOM-Recall',
                        ]}
                      >
                        <HomePage
                          key="precall"
                          ciDataInput="precall"
                          listDataInput={true}
                          listDataType="store"
                        />
                      </ProtectedElement>
                    }
                    exact
                  />
                  <Route
                    path="/recall_custom_notification"
                    element={
                      <ProtectedElement
                        allowed={[
                          ...commonPermissions,
                          'APP-OAUTH2-TOM-Recall',
                        ]}
                      >
                        <HomePage
                          key="precallcustom"
                          ciDataInput="precall"
                          listDataInput={true}
                          listDataType="teammember"
                        />
                      </ProtectedElement>
                    }
                    exact
                  />
                </Route>
              </Routes>
            </Grid>
          </Grid>
        </div>
        <footer className={classes.footer}>
          <div className={classes.insidefooter}>
            <Typography component="span" type="Title">
              Contact Us
            </Typography>
            <List
              dense={true}
              disablePadding={true}
              className={classes.footerList}
            >
              <a
                href="mailto:tts-hermod-all@target.com?subject=Hermod%20TOM%20Query"
                target="_blank"
                rel="noopener noreferrer"
              >
                <ListItem disableGutters={true} dense={true}>
                  <ListItemIcon>
                    <Email className={classes.icon} />
                  </ListItemIcon>
                  <ListItemText primary="Email Hermod" />
                </ListItem>
              </a>
              <a
                href="https://target-tts.slack.com/messages/C02260BQLLS/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <ListItem disableGutters={true} dense={true}>
                  <ListItemIcon>
                    <img
                      src="/slack.svg"
                      className={classes.icon}
                      alt="Slack"
                    />
                  </ListItemIcon>
                  <ListItemText primary="Hermod on Slack" />
                </ListItem>
              </a>
              <a
                href="https://github.com/target-corp/TargetOutreachManager-notifyui"
                target="_blank"
                rel="noopener noreferrer"
              >
                <ListItem disableGutters={true} dense={true}>
                  <ListItemIcon>
                    <img
                      src="/github.svg"
                      alt="Github"
                      className={classes.icon}
                    />
                  </ListItemIcon>
                  <ListItemText primary="T.O.M. on Github" />
                </ListItem>
              </a>
            </List>
          </div>
        </footer>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  headerTitle: state.layout.headerTitle,
  sideNavIsOpen: state.layout.sideNavIsOpen,
})

const actionCreators = {
  openSideNav,
  closeSideNav,
}

export default withAuth()(
  connect(mapStateToProps, actionCreators)(withStyles(styles)(AppLayout)),
)
